import {useGetJobPlanCascaderOptionsQuery} from "../../store/services/api/job-plan-api";
import {Select, SelectProps} from "antd";
import React, {useEffect} from "react";
import {JobPlan} from "../../store/data/entities/job-plan";

type JobPlanSelectProps = SelectProps<string> & {
  initialValues?: JobPlan[] | undefined;
  value?: string[] | undefined;
  onChange?: (value: string[]) => void;
}

export default function JobPlanFormControl(props: JobPlanSelectProps) {
  const {data: options, isLoading} = useGetJobPlanCascaderOptionsQuery();
  const jobPlanOptions = options?.map((option) => ({
    label: option.label,
    value: option.value,
  })) ?? [];

  useEffect(() => {
    if (!props.initialValues) return;
    props.onChange?.(props.initialValues.map((jobPlan) => jobPlan.id));
  }, [props.initialValues]);

  return (
    <Select
      {...props}
      options={isLoading ? [] : jobPlanOptions}
      loading={isLoading || props.loading}
      mode="multiple"
      optionFilterProp="label"
      placeholder="Please select"
    />
  )
}
